const validatePhoneNumber = (number) => {
  const re = /^(\+46|0)[\d\s-]{6,14}$/;
  return re.test(String(number));
};

export default validatePhoneNumber;
